import React, { HTMLAttributes } from 'react'
import icons from '@/assets/icons'
import { getImage } from '@/utils/utils'
import images from '@/assets/images'
import './index.less'

type SJImageCellProps = HTMLAttributes<HTMLDivElement> & {
  type?: 'normal' | 'check'
  image?: string
  name: string
  role: string
  checked?: boolean // 选中
}

const SJImageCell: React.FC<SJImageCellProps> = ({
  className,
  type = 'normal',
  image = '',
  name,
  role,
  checked = false,
  ...props
}) => {
  return (
    <div className={`sj-image-cell ${className ?? ''}`} {...props}>
      <img
        className="sj-image-cell-avatar"
        src={image ? getImage(image) : images.avatar_default}
        alt=""
      />
      <div className="sj-image-cell-content">
        <div className="sj-image-cell-content-title oneline">{name}</div>
        <div className="sj-image-cell-content-sub oneline">{role}</div>
      </div>
      {type === 'check' ? (
        <img
          className="sj-image-cell-icon"
          src={checked ? icons.IconRadioChecked : icons.IconRadioDefault}
          alt=""
        />
      ) : (
        <img className="sj-image-cell-icon" src={icons.IconRight} alt="" />
      )}
    </div>
  )
}

export default SJImageCell
